import { Accordion, AccordionSummary, Box, styled, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { StyleguideSavioColors } from "../../../../configuration/themeSettings";

export const useClasses = () => {

    const theme = useTheme();
    const classes = {
        text: {
            fontSize: 9,
            marginLeft: theme.spacing(4),
            textAlign: "left",
        } as SxProps,

        root: {
            position: "sticky",
            bottom: "15px",
            marginLeft: "50%",
            marginRight: "50%",
            zIndex: 999
        } as SxProps,
        buttonDesktop: {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.primary,
            height: "30px",
            justifyContent: "flex-start",
            // minWidth: "180px",  
            '&:hover': {
                backgroundColor: theme.palette.common.black
            },
            borderRadius: '25px',
            boxShadow: '0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)',
            whiteSpace: "nowrap",
            padding: "10px"
        } as SxProps,
        buttonX: {
            position: "sticky",
            marginLeft: "50%",
            marginRight: "50%",
            zIndex: 999
        } as SxProps,
    }
    return classes;

};

export const BoxButtonFilter = styled(Box, { label: "filter-accordion" })(({ theme }) => ({
    display: "flex",
    alignItems: "center",

    "button": {
        marginRight: 0 + " !important",
    }
}));

export const FilterAccordionDetails = styled(Accordion, { label: "filter-accordion-detail" })(({ theme }) => ({
    boxShadow: 'none',
    color: StyleguideSavioColors.text.black,
}));

export const FilterAccordion = styled(Accordion, { label: "filter-accordion" })(({ theme }) => ({
    boxShadow: "none",
    borderBottom: '2px solid ' + StyleguideSavioColors.lightGrey,
    borderRadius: "0 !important",


    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
    "&$expanded": {
        margin: "auto",
    },

    '> h3 + div':{
        marginTop:0,
    },
    expanded: {},
}));

export const FilterAccordionSummary = styled(AccordionSummary, { label: "filter-accordion-summary" })(({ theme }) => ({
    cursor: 'default !important',
    boxShadow: "none",
    paddingLeft: 4,
    paddingRight: 4,
    root: {
        minHeight: 34,

        "&$expanded": {
            minHeight: 44,
        },
    },
    '& .MuiAccordionSummary-content': {
        justifyContent: "flex-end",
        margin: "0 !important",
        "&$expanded": {
            margin: "6px 0 0 !important",
        },
    }
}));

export const FilterBox = styled(Box, { label: "filter-container" })(({ theme }) => ({
    
    "& >div": {
        backgroundColor: theme.palette.grey,
        borderRadius: "3px",
        borderBottom: '1px solid '+ StyleguideSavioColors.lightGrey,
    }
}));


export const IconClose = styled("div", { label: "icon-close" })(({ theme }) => ({
    borderRadius: 7,
    height: 16,
    width: 16,
    fontSize: 12,
    marginRight:3,
    marginLeft: 10,
    color: theme.palette.primary.main,
    cursor: "pointer",
    "&:hover":{
        color: StyleguideSavioColors.blue,
        backgroundcolor: StyleguideSavioColors.footerGrey,
        
    }
}));

export const FilterMachineMessage = styled("div", { label: "filter-machine-messager" })(({ theme }) => ({
    
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: StyleguideSavioColors.lightestGrey,
    color: StyleguideSavioColors.text.black,
    padding: 3,
    paddingLeft: 10,
    height: 25,
    borderRadius: 7,
    marginRight: 10,
    fontSize: 14,
    "svg":{
        fontSize: 10,
    },
    display:"flex",
    justifyContent: 'space-between',
    alignItems: 'center',
}));